/**
 * sắp xếp theo: để thiết lập các giá trị của nhóm dữ liệu
 * pqkhanh 16.05.2024
 */
export default {
  Name: 0,
  Code: 1,
};
